import urlJoin from 'url-join';

const normalizeUrl = (url: string) => url.replace(/([^:]\/)\/+/g, '$1');

const joinAndNormalizeUrl = (...paths: (string | undefined | null)[]) => {
    if (!paths || paths.length === 0) {
        return '';
    }

    const validPaths = (paths ?? []).filter(path => path !== null);

    return normalizeUrl(urlJoin(...validPaths));
};

export default joinAndNormalizeUrl;
